import React, { forwardRef, useEffect, useMemo, useRef, useState } from "react";
import "./global.scss";
import { BsArrowRight, BsShieldFillCheck } from "react-icons/bs";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import dateFormatter from "../../../utils/dateFormatter";
import useLoginAndRedirect from "../../../helper/useLoginAndRedirect";
import { useCountdown } from "../../../helper/useCountdown";
import { Skeleton } from "antd";
const Banner = forwardRef(({ bannerText, countdown }, ref) => {
  const currentTime = new Date();
  const targetTime = new Date();
  targetTime.setHours(5);
  targetTime.setMinutes(0);
  targetTime.setSeconds(0);
  if (currentTime > targetTime) {
    targetTime.setDate(targetTime.getDate() + 1);
  }
  const [countdownTime, setCountdownTime] = useState(targetTime);
  const {
    countDown: { intialValues, ...countDown },
  } = useCountdown(new Date(countdownTime));
  useEffect(() => {
    if (currentTime >= targetTime) {
      targetTime.setDate(targetTime.getDate() + 1);
      setCountdownTime(targetTime);
    }
  }, [countDown]);
  const slideArea = useRef(null);
  const slideContent = useRef(null);
  function handleMarquee() {
    let speed = 0.5;
    const elWidth = slideContent.current.offsetWidth;
    let clone = slideContent.current.cloneNode(true);
    slideArea.current.appendChild(clone);
    let progress = 1;
    function loop() {
      progress = progress - speed;
      if (progress <= elWidth * -1) {
        progress = 0;
      }
      if (slideArea.current) {
        slideArea.current.style.transform = "translateX(" + progress + "px)";
      }
      window.requestAnimationFrame(loop);
    }
    loop();
  }
  const isCountdownActive = useMemo(() => {
    if (new Date(countdown).valueOf() <= new Date().valueOf()) {
      return false;
    } else {
      return true;
    }
  }, [new Date(countdown)]);
  useEffect(() => {
    handleMarquee();
  }, []);
  return (
    <div className="flex banner" ref={ref}>
      <div className="flex scroll__slider" ref={slideArea}>
        <div className="flex banner__wrapper" ref={slideContent}>
          <p>{bannerText}</p>
          <p>{bannerText}</p>
          <p>{bannerText}</p>
        </div>
        <div className="flex banner__wrapper" ref={slideContent}>
          <p>{bannerText}</p>
          <p>{bannerText}</p>
          <p>{bannerText}</p>
        </div>
      </div>

      <div className="flex coundown-timer-wrapper">
        {!intialValues ? (
          <p className="secondary-heading">{`Ends In ${countDown.hours}h ${countDown.minutes}m ${countDown.seconds}s`}</p>
        ) : (
          <div className="flex countdown-loading-wrapper">
            <Skeleton.Input
              active
              style={{ height: "24px", width: "40px", minWidth: "unset" }}
            />
            <Skeleton.Input
              active
              style={{ height: "24px", width: "40px", minWidth: "unset" }}
            />
            <Skeleton.Input
              active
              style={{ height: "24px", width: "40px", minWidth: "unset" }}
            />
            <Skeleton.Input
              active
              style={{ height: "24px", width: "40px", minWidth: "unset" }}
            />
          </div>
        )}
      </div>
    </div>
  );
});
const FloatingButton = () => {
  const upcomingBatch = useSelector(
    (state) => state?.persistedReducer?.appConfigReducer?.upcomingBatch
  );
  const isLoggedIn = useSelector(
    (state) => state?.persistedReducer?.appConfigReducer?.isLoggedIn
  );
  const [isFloatingButtonActive, setIsFloatingButtonActive] = useState(false);
  const redirectHandler = useLoginAndRedirect();

  window.addEventListener("scroll", () => {
    if (window.scrollY >= 130) {
      setIsFloatingButtonActive(true);
    } else {
      setIsFloatingButtonActive(false);
    }
  });
  return (
    <div className="floating-container">
      <div
        className={`floating-button-wrapper ${
          isFloatingButtonActive ? "floating-btn-active" : ""
        }`}
      >
        <div className="flex">
          {!upcomingBatch || upcomingBatch.length == 0 ? (
            <div className="flex text">
              <p>The enrollments have been closed</p>
            </div>
          ) : (
            <div className="flex text">
              <p>This Batch Starts From</p>
              <span>{dateFormatter(upcomingBatch?.liveDate)}</span>
            </div>
          )}
          {!upcomingBatch || upcomingBatch.length == 0 ? (
            <Link to={`/}`} className="flex primary-btn">
              Enrollment Full
            </Link>
          ) : isLoggedIn && upcomingBatch?.isUserEnrolled ? (
            <Link to={"/classroom"} className="flex primary-btn">
              Already Enrolled <BsArrowRight size={18} />
            </Link>
          ) : (
            <div onClick={redirectHandler(`/checkout/${upcomingBatch?.slug}`)}>
              <Link className="flex primary-btn">
                Enroll Now <BsArrowRight size={18} />
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const SectionHeading = ({ heading, subText, color }) => {
  return (
    <>
      <div className="section-heading-wrapper">
        {heading && <h3 style={{ color }}>{heading}</h3>}
        <p dangerouslySetInnerHTML={{ __html: subText }} />
      </div>
    </>
  );
};

const SectionBanner = () => {
  return (
    <>
      <div className="hurryup-banner-container">
        <div className="section-banner-wrapper container-wrapper">
          <p className="flex">
            <BsShieldFillCheck size={20} />A Certified 5-Months Program To
            Assure Your Success
          </p>
        </div>
      </div>
    </>
  );
};

const ApplyNowBanner = () => {
  const upcomingBatch = useSelector(
    (state) => state?.persistedReducer?.appConfigReducer?.upcomingBatch
  );
  const isLoggedIn = useSelector(
    (state) => state?.persistedReducer?.appConfigReducer?.isLoggedIn
  );
  const redirectHandler = useLoginAndRedirect();
  return (
    <>
      <div className="apply-now-banner-wrapper">
        <div className="inner-apply-now-banner container-wrapper">
          <h3>Skills gets you the Job, Not your Degree.</h3>

          {!upcomingBatch || upcomingBatch.length == 0 ? (
            <div className="apply-now-btn-wrapper">
              <Link to={`/`} className="primary-btn apply-now-btn">
                Enrollment Full
              </Link>
            </div>
          ) : isLoggedIn && upcomingBatch?.isUserEnrolled ? (
            <div className="apply-now-btn-wrapper">
              <Link to={"/classroom"} className="primary-btn apply-now-btn">
                Already Enrolled
              </Link>
            </div>
          ) : (
            <div
              className="apply-now-btn-wrapper"
              onClick={redirectHandler(`/checkout/${upcomingBatch?.slug}`)}
            >
              <Link className="primary-btn apply-now-btn">Apply Now</Link>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

const CourseHighlights = ({ title, icon, desc }) => {
  return (
    <>
      <div className="flex course-highlights-wrapper">
        {icon}
        <div className="flex text-wrapper">
          <p>{title}</p>
          <span>{desc}</span>
        </div>
      </div>
      <span></span>
    </>
  );
};

const UserProfileWithCompany = ({
  name,
  company,
  studentImg,
  companyImg,
  imgSize,
}) => {
  return (
    <>
      <div className="flex student-name-profile-image">
        <img
          src={studentImg}
          alt="student-profile"
          width={imgSize || "60px"}
          loading="lazy"
        />
        <div className="student-name-position">
          <p>{name}</p>
          <span>{company}</span>
          <img src={companyImg} alt="" />
        </div>
      </div>
    </>
  );
};
export {
  ApplyNowBanner,
  Banner,
  FloatingButton,
  SectionHeading,
  SectionBanner,
  CourseHighlights,
  UserProfileWithCompany,
};
